// extracted by mini-css-extract-plugin
export default {"noteListWrapper":"NotesList_noteListWrapper__g3BIL"};